import restaurantModalLoginInstance from '../../modalLoginInstance'
import restaurantInstance from '../../instance'

const storeTableSplit = (tableId, data, hasModalLogin = true) => {
  return (hasModalLogin ? restaurantModalLoginInstance : restaurantInstance)
    .post(`/tables/${tableId}/splits`, data)
}

export default storeTableSplit
